import {
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

const colWidths = [120, 140, 110, 180, 110, 160, 80];

interface DiscountTableSkeletonProps {
  labels?: string[];
  page?: number;
  count?: number;
}

const DiscountTableSkeleton = ({
  labels = [
    "Name",
    "Eligible Country",
    "Eligible City",
    "Discount code",
    "Discount Amount",
    "Valid Date",
    "Usage per code",
    "Usage per user",
    "Discount Type",
    "Active",
    "Action",
  ],
}: DiscountTableSkeletonProps) => {
  return (
    <div className="mb-2 flex w-full flex-col overflow-hidden">
      <TableContainer className="rounded-[5px] pb-6">
        <Table stickyHeader aria-label="skeleton table">
          <TableHead>
            <TableRow>
              {labels.map((_, idx) => (
                <TableCell
                  key={idx}
                  className="h-[42px] bg-white py-0 text-[12px]"
                >
                  <Skeleton
                    variant="text"
                    width={colWidths[idx] || 100}
                    height={24}
                    sx={{ borderRadius: 1 }}
                  />
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {[...Array(5)].map((_, rowIdx) => (
              <TableRow key={rowIdx}>
                {labels.map((_, colIdx) => (
                  <TableCell
                    key={colIdx}
                    className="bg-white text-[12px] text-primary"
                  >
                    <Skeleton
                      variant="rounded"
                      width={colWidths[colIdx] || 100}
                      height={28}
                      sx={{ borderRadius: 2, mb: 0.5 }}
                      animation="wave"
                    />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default DiscountTableSkeleton;
